/* HB ROUND 4 — assets/hb-round4.js (19 Oct 2026)
   Turns each combo's plain step text into a numbered list.
   hb-combo.js renders asynchronously and re-renders as stock resolves, so a
   MutationObserver re-runs this; every converted node is flagged, so the
   observer seeing our own edits is a no-op. No third-party code. */
(function () {
  'use strict';
  if (window.__hbRound4) return;
  window.__hbRound4 = 1;

  function convert(root) {
    var nodes = (root || document).querySelectorAll('.cmb__steps:not([data-hb-ol])');
    Array.prototype.forEach.call(nodes, function (p) {
      p.setAttribute('data-hb-ol', '1');
      var raw = p.textContent.replace(/…\s*$/, '').trim();
      var lines = raw.split(/\n+|(?<=\.)\s+(?=[A-Z])/).map(function (s) { return s.trim(); }).filter(Boolean);
      /* The stored step text is cut at a fixed length, so the last step is often
         a fragment ("C", "Tap Ash"). Drop it and point to the full write-up. */
      var cut = false;
      if (lines.length > 1 && !/[.!?)\]}"']$/.test(lines[lines.length - 1])) { lines.pop(); cut = true; }
      if (lines.length < 2 && !cut) return;
      var ol = document.createElement('ol');
      ol.className = 'cmb__ol';
      lines.forEach(function (t) {
        var li = document.createElement('li');
        li.textContent = t;
        if (/^repeat\b/i.test(t)) li.className = 'is-loop';
        ol.appendChild(li);
      });
      if (cut) {
        var full = p.parentNode.querySelector('.cmb__link');
        var li2 = document.createElement('li');
        li2.className = 'cmb__olmore';
        if (full) {
          var a = document.createElement('a');
          a.href = full.href; a.target = '_blank'; a.rel = 'noopener';
          a.textContent = 'See the remaining steps on Commander Spellbook →';
          li2.appendChild(a);
        } else {
          li2.textContent = 'More steps on Commander Spellbook.';
        }
        ol.appendChild(li2);
      }
      p.hidden = true;
      p.parentNode.insertBefore(ol, p.nextSibling);
    });
  }

  var t = 0;
  function soon() { if (t) return; t = setTimeout(function () { t = 0; convert(); }, 120); }

  function start() {
    convert();
    if ('MutationObserver' in window) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Accessibility pass (20 Oct 2026): a pause/play button for the moving card ticker (WCAG 2.2.2). */
(function () {
  'use strict';
  function add() {
    Array.prototype.forEach.call(document.querySelectorAll('.hb-ticker:not([data-hb-pause])'), function (tk) {
      tk.setAttribute('data-hb-pause', '1');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hb-tickpause';
      b.setAttribute('aria-pressed', 'false');
      b.textContent = 'Pause';
      b.addEventListener('click', function () {
        var on = tk.classList.toggle('is-paused');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.textContent = on ? 'Play' : 'Pause';
      });
      tk.appendChild(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();
